import { LogOut } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { ROLE_LABELS } from '../../utils/constants';

export function SidebarUserCard({ user, collapsed, onLogout }) {
  if (!user) return null;

  if (collapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={onLogout}
            className="flex items-center justify-center w-full px-3 py-2 rounded-md text-sm text-muted-foreground hover:bg-destructive/10 hover:text-destructive"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="right">Log out</TooltipContent>
      </Tooltip>
    );
  }

  const initials = (user.first_name?.[0] || '') + (user.last_name?.[0] || '');

  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <div className="w-8 h-8 rounded-full bg-gold-100 text-gold-800 flex items-center justify-center text-xs font-semibold shrink-0 ring-1 ring-gold/40">
        {initials}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium truncate">{user.first_name} {user.last_name}</p>
        <p className="text-xs text-muted-foreground">{ROLE_LABELS[user.role] || user.role}</p>
      </div>
      <button
        onClick={onLogout}
        className="p-1.5 rounded-md text-muted-foreground hover:bg-destructive/10 hover:text-destructive"
        data-testid="logout-btn"
        title="Log out"
      >
        <LogOut className="w-4 h-4" />
      </button>
    </div>
  );
}
